import '../styles/index.scss';

/**
 * @constructor
 */
(() => {
    setTimeout(() => {
        document.body.classList.remove('preload');
        document.body.classList.add('preloaded');
    }, 100);

    const collapseEl = document.querySelector('.collapse');
    collapseEl && import('./component/collapse').then((obj) => obj.default());

    const sidebarElement: HTMLElement | null = document.getElementById('sidebar-cnt');
    sidebarElement && import('./component/sidebar').then((obj) => obj.default(sidebarElement));

    const sidebarNavElement: HTMLElement | null = document.querySelector('.sidebar-nav');
    sidebarNavElement && import('./component/sidebarNav').then((obj) => obj.default(sidebarNavElement));

    const uicCollapseEl: NodeListOf<HTMLElement> = document.querySelectorAll('uic-collapse');
    uicCollapseEl && import('./component/uicCollapse').then((obj) => obj.default(uicCollapseEl));

    const uicTabsElements: NodeListOf<HTMLElement> = document.querySelectorAll('uic-tabs');
    uicTabsElements && import('./component/uicTabs').then((obj) => obj.default(uicTabsElements));

    const galleryElements: HTMLElement | null = document.querySelector('.gallery');
    galleryElements && import('./component/gallery').then((obj) => obj.default());

    const loadbeeElement: HTMLElement | null = document.querySelector('infonet-loadbee');
    loadbeeElement && import('./component/loadbee').then((obj) => obj.default(loadbeeElement));

    const loginFormEl: HTMLFormElement | null = document.getElementById('login-form') as HTMLFormElement;
    loginFormEl && import('./component/loginForm').then((obj) => obj.default(loginFormEl));

    const iframeResizerElements: NodeListOf<HTMLElement> = document.querySelectorAll('iframe[data-resize="1"]');
    iframeResizerElements.length &&
        import('./component/iframeResize').then((obj) => obj.default(iframeResizerElements));

    const copyrightEl: HTMLElement | null = document.getElementById('copyright');
    copyrightEl && (copyrightEl.innerText = String(new Date().getFullYear()));

    const browserWarningEl: HTMLElement | null = document.getElementById('browserWarning');
    browserWarningEl && import('./component/browserWarning').then((obj) => obj.default(browserWarningEl));
})();
